/**
 * @generated SignedSource<<2c44481b065fec738e6cbf70eacef1d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MyPageCategory$data = {
  readonly influencerCategories: ReadonlyArray<{
    readonly categoryName: string;
    readonly id: string;
  }>;
  readonly " $fragmentType": "MyPageCategory";
};
export type MyPageCategory$key = {
  readonly " $data"?: MyPageCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyPageCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyPageCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerCategory",
      "kind": "LinkedField",
      "name": "influencerCategories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "d5dd4e75b05963c5934b84c3828f4b01";

export default node;
